var hashFragment = window.location.hash;
var NO_TOKEN = '__NO_TOKEN__';
export function pluckTokenFromHash() {
  var clearHash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var accessToken = /access_token=([^&]+)&?/;
  var hasToken = hashFragment.match(accessToken);
  var token = hasToken ? hasToken[1] : process.env.REACT_APP_ACCESS_TOKEN;
  if (token && token !== NO_TOKEN) {
    if (clearHash) window.location.hash = '';
    return token;
  }
}